var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRacBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1433.313,
    height: 128.183,
    viewBox: "0 0 1433.313 128.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10244",
    "data-name": "Group 10244",
    transform: "translate(-242.479 -341.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10218",
    "data-name": "Group 10218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10217",
    "data-name": "Group 10217",
    transform: "translate(0 -249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26414",
    "data-name": "Path 26414",
    d: "M-10657.662-1503.216l23.648,25.175,1405.693-.126-26.5-25.257Z",
    transform: "translate(10900.141 2194.685)",
    fill: "#b0c4e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26415",
    "data-name": "Path 26415",
    d: "M-9262-1599.331v98.7l29.536,27.878-2.529-103.84Z",
    transform: "translate(10906.813 2189.661)",
    fill: "#b0c5e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26416",
    "data-name": "Path 26416",
    d: "M-10662.36-1331.491l22.435,26.214,1405.523-.351-27.906-26.5",
    transform: "translate(10906 2022)",
    fill: "none",
    stroke: "#3d444e",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9287",
    "data-name": "Rectangle 9287",
    width: 1400,
    height: 98,
    transform: "translate(244 592)",
    fill: "#e7eef8",
    stroke: "#3d444e",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26417",
    "data-name": "Path 26417",
    d: "M-9231.708-1304.141l-2.044-104.94-27.473-21.7",
    transform: "translate(10906 2022)",
    fill: "none",
    stroke: "#3d444e",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    id: "Thank_you_for_choosing_Rent_A_Center_",
    "data-name": "Thank you for choosing Rent A Center!",
    transform: "translate(957 403)",
    fill: "#1d8edc",
    fontSize: 53,
    fontFamily: "HarlowSolid, Harlow Solid"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -421.969,
    y: 0
  }, "Thank you for choosing Rent A Center!"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacBanner);
export default __webpack_public_path__ + "static/media/RAC-Banner.e9392586.svg";
export { ForwardRef as ReactComponent };